export function clickAndDrag(slider, scroll_speed = 1, classOnEvent = 'grabbed_elem') {
    let isDown = false;
    let startX;
    let scrollLeft;
    let isDragging = false;
    let velocity = 0;
    let lastX;
    let lastMoveTime;
    let momentumAnimationId;
    let autoplayInterval;
    let isUserInteracting = false;
    let isScrolling = false;
    const autoplayDelay = parseInt(slider.getAttribute('data-autoplay') || '0', 10);
    const dragContainer = slider.querySelector('.drag-container');
    const navWrapper = slider.nextElementSibling?.matches('[data-navigation]')
        ? slider.nextElementSibling
        : null;
    const btnPrev = navWrapper?.querySelector('[data-navigation-prev]');
    const btnNext = navWrapper?.querySelector('[data-navigation-next]');
    if (autoplayDelay > 0 && dragContainer) {
        startAutoplay();
    }
    slider.addEventListener('mousedown', (e) => {
        e.preventDefault();
        isDown = true;
        isDragging = false;
        isUserInteracting = true;
        slider.classList.add(classOnEvent);
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
        lastX = startX;
        lastMoveTime = Date.now();
        stopAutoplay();
        cancelMomentum();
        const onMouseUp = (e) => {
            if (isDown) {
                isDown = false;
                slider.classList.remove(classOnEvent);
                if (isDragging) {
                    e.preventDefault();
                    applyMomentum();
                }
                document.removeEventListener('mouseup', onMouseUp);
                document.removeEventListener('mousemove', onMouseMove);
                setTimeout(() => {
                    if (!isDown && autoplayDelay > 0) {
                        isUserInteracting = false;
                        startAutoplay();
                    }
                }, 1000);
            }
        };
        const onMouseMove = (e) => {
            if (!isDown)
                return;
            isDragging = true;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * scroll_speed;
            const currentTime = Date.now();
            const deltaTime = currentTime - lastMoveTime;
            velocity = (x - lastX) / deltaTime;
            slider.scrollLeft = scrollLeft - walk;
            lastX = x;
            lastMoveTime = currentTime;
            updateNavigationButtons();
        };
        document.addEventListener('mouseup', onMouseUp);
        document.addEventListener('mousemove', onMouseMove);
    });
    function applyMomentum() {
        if (Math.abs(velocity) > 0.1) {
            isScrolling = true;
            slider.scrollLeft -= velocity * 20;
            velocity *= 0.95;
            updateNavigationButtons();
            momentumAnimationId = requestAnimationFrame(applyMomentum);
        }
        else {
            cancelAnimationFrame(momentumAnimationId);
            isScrolling = false;
            updateNavigationButtons();
        }
    }
    function cancelMomentum() {
        cancelAnimationFrame(momentumAnimationId);
        isScrolling = false;
    }
    function handleClick(event) {
        if (isDragging && event.target === slider) {
            event.preventDefault();
            event.stopPropagation();
        }
    }
    document.addEventListener('click', handleClick, true);
    function startAutoplay() {
        if (autoplayDelay === 0)
            return;
        stopAutoplay();
        autoplayInterval = window.setInterval(() => {
            if (!isUserInteracting && dragContainer) {
                autoplayScroll();
            }
        }, autoplayDelay);
    }
    function stopAutoplay() {
        if (autoplayInterval) {
            clearInterval(autoplayInterval);
            autoplayInterval = undefined;
        }
    }
    function autoplayScroll(forward = true) {
        if (!dragContainer || isScrolling)
            return;
        const firstItem = dragContainer.children[0];
        if (!firstItem)
            return;
        const itemWidth = firstItem.offsetWidth;
        const computedStyle = getComputedStyle(dragContainer);
        const gap = parseFloat(computedStyle.gap) || 0;
        const scrollAmount = itemWidth + gap;
        isScrolling = true;
        if (forward) {
            const maxScrollLeft = slider.scrollWidth - slider.clientWidth;
            if (slider.scrollLeft >= maxScrollLeft - 1) {
                slider.scrollTo({ left: 0, behavior: 'smooth' });
            }
            else {
                slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
            }
        }
        else {
            if (slider.scrollLeft <= 1) {
                const maxScrollLeft = slider.scrollWidth - slider.clientWidth;
                slider.scrollTo({ left: maxScrollLeft, behavior: 'smooth' });
            }
            else {
                slider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
            }
        }
        setTimeout(() => {
            isScrolling = false;
            updateNavigationButtons();
        }, 400);
    }
    function updateNavigationButtons() {
        if (!btnPrev || !btnNext)
            return;
        btnPrev.classList.toggle('disabled', slider.scrollLeft <= 1);
        btnNext.classList.toggle('disabled', slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 1);
    }
    if (btnPrev) {
        btnPrev.addEventListener('click', () => {
            isUserInteracting = true;
            stopAutoplay();
            cancelMomentum();
            autoplayScroll(false);
            setTimeout(() => {
                isUserInteracting = false;
                startAutoplay();
            }, 1000);
        });
    }
    if (btnNext) {
        btnNext.addEventListener('click', () => {
            isUserInteracting = true;
            stopAutoplay();
            cancelMomentum();
            autoplayScroll(true);
            setTimeout(() => {
                isUserInteracting = false;
                startAutoplay();
            }, 1000);
        });
    }
    updateNavigationButtons();
    slider.addEventListener('scroll', updateNavigationButtons);
}
